import clientErrorMutation from '../../../apollo/mutations/clientErrorMutation.graphql';
import apolloClient from '../../../apollo/apolloClient';

const updateLogs = async (errorCode, traceId) => {
  await apolloClient.mutate({
    mutation: clientErrorMutation,
    variables: {
      errorCode,
      traceId,
      id: Math.random(),
    },
  });
};

export default updateLogs;
